import { Divider, Box, Card, CardContent, Grid, Pagination, Typography } from "@mui/material";
import { useState } from "react";
import { IPlanComment } from "../types/interfaces/IPlanComment";
import { ICommentListProps } from "../types/interfaces/ICommentListProps";

//This component is responsible for displaying a list of plan comments.
const CommentList: React.FC<ICommentListProps> = ({ planComments }) =>  {
    if (planComments === null || (planComments.length === 1 && planComments[0] === null)) return null;

    const [page, setPage] = useState(1);
    const commentsPerPage = 3;
    const count = Math.ceil(planComments.length/commentsPerPage);
    const paginatedComments = planComments.slice((page - 1) * commentsPerPage, page * commentsPerPage);

    //Function to handle the page change.
    const pageChange = (event: React.ChangeEvent<unknown>, value: number) => {
        setPage(value);
    };

    return (
        <>
            <Typography variant="h6" color="black" component="div">
                <Box sx={{ fontWeight: 'bold' }}>Comments</Box>
            </Typography>
            <Grid container spacing={1} sx={{mt:1, mb:1}}>
                {paginatedComments.map((planComment: IPlanComment | any ) => (
                    <Grid item xs={12} sm={6} md={4} key={planComment.CommentKey} style={{ display: 'flex', flexDirection: 'column' }}>
                        <Card sx={{ border: 1, borderColor: 'divider' }}>
                            <CardContent sx={{ paddingBottom: 0 }}>
                                <Box display="flex" alignItems="center">
                                    <Typography variant="body2" component="div" sx={{wordBreak: 'break-word'}}>{planComment.Comment}</Typography>
                                </Box>
                                <Box display="flex" alignItems="center">
                                    <Typography variant="body2" fontWeight="bold" color="black" mr={1}>Reviewed by:</Typography>
                                    <Typography variant="body2" component="div" sx={{wordBreak: 'break-word'}}>{planComment.Commenter.FirstName} {planComment.Commenter.LastName}</Typography>
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
            <Pagination count={count} page={page} onChange={pageChange} variant="outlined" shape="rounded" showFirstButton showLastButton sx={{mt:1, mb:5}} />
            <Divider sx={{mt:1, mb:5}}></Divider>
        </>
    );
}

export default CommentList;